<table class="table table-bordered" id="table" width="100%" cellspacing="0">
  <thead>
    <tr>
      <th>{{ categoryI18n?.category_nameI18n }}</th>
    </tr>
  </thead>
  <tfoot>
    <tr>
      <th>{{ categoryI18n?.category_nameI18n }}</th>
    </tr>
  </tfoot>
  <tbody>
    <tr *ngFor="let c of categories">
      <td>{{ c.category_name }}</td>
    </tr>
  </tbody>
</table>
